import { render } from "./langIcon.vue?vue&type=template&id=fa70366a"
import script from "./langIcon.vue?vue&type=script&lang=js"
export * from "./langIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/advocacy/e-advokat-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__